import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import {
  Header,
  Grid,
  Modal,
  Button,
  Icon,
  Input,
  Label
} from "semantic-ui-react";
import { basename, extension, directory } from "../../utils/helpers";
import Flagship from "../../core/flagship";

class RenameFileModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
  }

  getInitialState() {
    return {
      newFilename: this.props.initialFilename,
      fileExtension: extension(this.props.initialFilename),
      fileDirectory: directory(this.props.initialFilename)
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.initialFilename !== prevProps.initialFilename) {
      this.setState(
        {
          newFilename: this.props.initialFilename,
          fileExtension: extension(this.props.initialFilename),
          fileDirectory: directory(this.props.initialFilename)
        },
        function() {
          const input = ReactDOM.findDOMNode(
            document.querySelector(".rename-file input")
          );
          if (input !== null) {
            input.focus();
            input.select();
          }
        }
      );
    }
  }

  onChange(e, input) {
    this.setState({
      newFilename:
        this.state.fileDirectory + input.value + "." + this.state.fileExtension
    });
  }

  saveAndExit() {
    let onRenameFile = this.props.onRenameFile;
    let initialFilename = this.props.initialFilename;
    let newFilename = this.state.newFilename;

    this.props.beforeRenameFile();

    Flagship.post(
      "rename-file",
      {
        initialFilename,
        newFilename
      },
      function(response) {
        if (response.data.success === true) {
          Flagship.notify("File renamed.");
          onRenameFile();
        } else {
          Flagship.error("Error renaming file: " + response);
        }
      }
    );
  }

  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.cancelRename}
        closeIcon
        width={500}
      >
        <Header icon="edit" content="Rename File" />
        <Modal.Content>
          <div>
            <Grid>
              <Grid.Column width={16}>
                <div className="rename-file">
                  <Label>File Name</Label>
                  <br />
                  <br />
                  <Input
                    type="text"
                    fluid
                    labelPosition="right"
                    onChange={this.onChange}
                    placeholder={basename(this.props.initialFilename)}
                    value={basename(this.state.newFilename)}
                  >
                    <input />
                    <Label>{"." + this.state.fileExtension}</Label>
                  </Input>
                </div>

                <small style={{ color: "#666" }}>
                  Choose a new name for this file.
                </small>
              </Grid.Column>
            </Grid>
          </div>
        </Modal.Content>
        <Modal.Actions>
          {basename(this.state.newFilename) !== "" ? (
            <Button primary onClick={this.saveAndExit}>
              <Icon name="save" /> Save New Filename
            </Button>
          ) : null}
          <Button color="grey" onClick={this.props.cancelRename}>
            <Icon name="dont" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(RenameFileModal);



// WEBPACK FOOTER //
// ./src/components/modals/RenameFileModal.js